import React from 'react'
import BusinessSetup from '../../../settings/pages/profile-and-account-setup/components/BusinessSetup'

const EditClient = () => {
  
const businessInfoData: any = JSON.parse(sessionStorage.getItem('activeClient') || '{}') 
 
  return (
    <div>
        <BusinessSetup businessInfoData={
            {
                name: businessInfoData?.name ,
                email: businessInfoData?.email,
                phoneNumber: businessInfoData?.phoneNumber,
                country: businessInfoData?.country, 
                address: businessInfoData?.address,
                size: businessInfoData?.size,
                state: businessInfoData?.state,
                type: businessInfoData?.type,
                paymentType: businessInfoData?.paymentType,
              }
        } />
    </div>
  )
}

export default EditClient